import { useCallback, useMemo } from 'react';

import { useIsLargerThanWide } from '../../styles/hooks/media';
import { useCoreDispatch } from '../CoreStore';
import { autoplayActions } from '../slices/autoplay/slice';
import { useGameStateSlice } from '../slices/game/selectors';
import { gameStateActions } from '../slices/game/slice';
import { headerActions } from '../slices/header/slice';

export const useDrawerHidden = (): boolean => {
  const hideUI = useGameStateSlice.hideUI();
  const desktop = useIsLargerThanWide();

  return useMemo(() => {
    return !desktop && hideUI;
  }, [hideUI, desktop]);
};

export const useActiveDialogCleaner = (): (() => void) => {
  const dispatch = useCoreDispatch();
  const hideDrawer = useDrawerHidden();

  return useCallback((): void => {
    // Close Lobby
    dispatch(headerActions.setMiniLobbyOpen(false));
    // CLose Modals For Desktop (History, Help, Settings)
    dispatch(headerActions.setOpenedModal(null));
    // CLose Modals For Mobile (History, Help, Settings)
    dispatch(headerActions.setNavRoute([]));

    if (hideDrawer) {
      dispatch(gameStateActions.setOpenLeftDrawer(null));
      dispatch(autoplayActions.toggle(false));
    }

    // Disable Hide UI functionality
    dispatch(gameStateActions.setHideUI(false));
  }, [dispatch, hideDrawer]);
};
